import React, { useState } from 'react';
import './style.css';
import { Collapse } from 'react-collapse';
import { AiOutlineSearch } from 'react-icons/ai';
import Grid from '@material-ui/core/Grid';
import Logo from './../../../assets/botao-estudante.png';
import DrawLeft from './../../../assets/botao-medico_especialista.png';
import DrawRight from './../../../assets/botao-medico_tutor.png';
import { NavLink } from 'react-router-dom';
import SideNav from './../../../components/SideNav_PS';

export default function Tela_PS_Cadastro() {
    let [search, setSearch] = useState(false);
    return (
        <> 
        <SideNav />
        <body id="body-PS">
        <div id="top-PS">
        <Grid container spacing={0} direction="row" justify="left"  alignItems="center" style={{ marginTop: '-35vh'}}>
            <Grid item xs={2} sm={2} md={1} lg={1} align="center"></Grid>
            <Grid item xs={8} sm={8} md={10} lg={10}></Grid>   
            <Grid item xs={2} sm={2} md={1} lg={1} align="center"> 
                <Collapse isOpened={search}>
                    <input id="Tela_PS" type="text" placeholder="pesquisa..." />
                </Collapse>
                <AiOutlineSearch
                    size={"6vh"}
                    onClick={() =>
                        setSearch(!search)
                    }
                    id="Icon-Search-PS"
                />
            </Grid>
        </Grid>
        </div>
        <Grid container spacing={0} direction="row" justify="center"  alignItems="center" style={{ minHeight: '80vh', maxWidth: '100%' }}> 
            <Grid item xs={12} sm={12} md={0} lg={1}></Grid>
            <Grid item xs={12} sm={12} md={4} lg={3} align="center">
                <img src={DrawRight} alt="Médico Tutor" id="responsive"></img>
                <NavLink to="/cad_medico_tutor"> <button id="esquerda">Tutor</button></NavLink>
                <h2 id="p-descritivo">Além de aceitar e fazer consultas, este será responsável por validar os resultados dos alunos antes do envio</h2>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={3} align="center">
                <img src={DrawLeft} alt="Médico Especialista" id="responsive"></img>
                <NavLink to="/cad_medico_espec"><button id="centro">Profissional da Saúde</button></NavLink>
                <h2 id="p-descritivo">Os profissionais da saúde <br></br>serão responsáveis <br></br>por aceitar e fazer <br></br>consultas</h2>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={3} align="center">
                <img src={Logo} alt="Estudante" id="responsive"></img>
                <NavLink to="/cad_estudante"><button id="direita">Estudante</button></NavLink>
                <h2 id="p-descritivo">Os estudantes serão responsáveis por condutas, consultas e receitas que serão avaliados pelos tutores</h2>
            </Grid>
            <Grid item xs={12} sm={12} md={0} lg={1}></Grid>
        </Grid>
        </body>    

        </>
    );
}